// ------------------------------------
// OPÇÕES
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'biolink-var';
    const ref2 = 'biolink';
    const refEvtPrefix = 'lp-evt-biolink-';

    // Elementos
    const $section = $('#biolink');

    if ($section.length > 0) {
      // Altera o layout
      function changeLayout() {
        const layoutClass = confTheme[ref2]['layout'];
        $section.removeClass('st1 st2 st3').addClass(layoutClass);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'layout', changeLayout);

      // Altera o tipo de fundo
      function changeBgType() {
        const value = confTheme[ref2]['bg-type'];
        if (value == 'image') {
          changeBgImage();
        } else if (value == 'gradient') {
          changeBgGradient();
        } else if (value == 'color') {
          changeBgColor();
        }
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'bg-type', changeBgType);

      // Altera a imagem de fundo
      function changeBgImage() {
        const image = confTheme[ref2]['bg-image'];
        $section.find('.biolink-bg').css('background-image', 'url(' + image + ')');
      }
      $root.on(refEvtPrefix + 'bg-image', changeBgImage);

      // Altera o gradiente de fundo
      function changeBgGradient() {
        const value = confTheme[ref2]['bg-gradient'];
        $section.find('.biolink-bg').css('background-image', value);
      }
      $root.on(refEvtPrefix + 'bg-gradient', changeBgGradient);

      // Altera a cor de fundo
      function changeBgColor() {
        const color = confTheme[ref]['header-bg-color'];
        $section.find('.biolink-bg').css('background-image', 'none');
        $section[0].style.setProperty('--header-bg-color', color);
      }
      $root.on(refEvtPrefix + 'bg-color', changeBgColor);
    }
  }
})();

// ------------------------------------
// LOGOTIPO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'biolink-var';
    const ref2 = 'biolink';
    const refEvtPrefix = 'lp-evt-biolink-';

    // Elementos
    const $image = $('.biolink-logo');

    if ($image.length > 0) {
      // Altera a imagem
      function changeImage() {
        const image = confTheme[ref2]['logo-src'];
        $image.find('img').attr('src', image);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'logo-src', changeImage);

      // Altera o texto alternativo da imagem
      function changeImageAlt() {
        const value = confTheme[ref2]['logo-alt'];
        $image.find('img').attr('alt', value);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'logo-alt', changeImageAlt);

      // Altera o formato da imagem
      function changeImageFormat() {
        const value = confTheme[ref2]['logo-format'];
        $image.removeClass('square rounded circle').addClass(value);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'logo-format', changeImageFormat);
    }
  }
})();

// ------------------------------------
// TEXTOS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'biolink-var';
    const ref2 = 'biolink';
    const refEvtPrefix = 'lp-evt-biolink-';

    // Elementos
    const $section = $('#biolink');
    const $secTitle = $('.biolink-tit');
    const $secText = $('.biolink-txt');

    if ($section.length > 0) {
      // Altera a cor de fundo
      function changeBgColor() {
        const color = confTheme[ref]['content-bg-color'];
        $section[0].style.setProperty('--content-bg-color', color);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'content-bg-color', changeBgColor);

      // Altera o título
      function changeTitle() {
        const value = confTheme[ref2]['title'];
        $secTitle.html(fmtTxt(value, true));
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'title', changeTitle);

      // Altera a cor do título
      function changeTitColor() {
        const color = confTheme[ref]['content-tit-color'];
        $section[0].style.setProperty('--content-tit-color', color);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'tit-color', changeTitColor);

      // Altera o texto
      function changeText() {
        const value = confTheme[ref2]['text'];
        $secText.html(fmtTxt(value));
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'text', changeText);

      // Altera a cor do texto
      function changeTxtColor() {
        const color = confTheme[ref]['content-txt-color'];
        $section[0].style.setProperty('--content-txt-color', color);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'txt-color', changeTxtColor);
    }
  }
})();

// ------------------------------------
// REDES SOCIAIS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'biolink-var';
    const ref2 = 'biolink';
    const refEvtPrefix = 'lp-evt-biolink-';

    // Elementos
    const $section = $('#biolink');
    const $element = $('.biolink-redes');

    // Oculta/Exibe o elemento
    function changeElShow() {
      const value = confTheme[ref2]['redes-show'];
      value == '1' ? $element.removeClass('d-none') : $element.addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'redes-show', changeElShow);

    // Altera o formato dos botões
    function changeIconFormat() {
      const value = confTheme[ref2]['redes-format'];
      $element.find('.social-icon').removeClass('si-square si-rounded si-circle').addClass(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'redes-format', changeIconFormat);

    // Altera a cor de fundo
    function changeBgColor() {
      const color = confTheme[ref]['social-bg-color'];
      $section[0].style.setProperty('--social-bg-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'social-bg-color', changeBgColor);

    // Altera a cor do texto
    function changeTxtColor() {
      const color = confTheme[ref]['social-icon-color'];
      $section[0].style.setProperty('--social-icon-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'social-icon-color', changeTxtColor);
  }
})();

// ------------------------------------
// REDES SOCIAIS (LISTA)
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'biolink-var';
    const ref2 = 'biolink';
    const refEvtPrefix = 'lp-evt-biolink-';

    // Lista de SVG's
    const socialIconsSVG = {
      'fab fa-facebook-f':
        '<svg class="facebook" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"/></svg>',
      'fab fa-instagram':
        '<svg class="instagram" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/></svg>',
      'fab fa-twitter':
        '<svg class="twitter" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/></svg>',
      'fab fa-linkedin-in':
        '<svg class="linkedin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"/></svg>',
      'fab fa-youtube':
        '<svg class="youtube" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"/></svg>',
      'fab fa-whatsapp':
        '<svg class="whatsapp" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/></svg>',
      'fab fa-telegram-plane':
        '<svg class="telegram" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"/></svg>',
      'fab fa-tiktok':
        '<svg class="tiktok" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"/></svg>',
    };

    // Elementos
    const $list = $('.biolink-redes');

    // Altera a lista
    function changeList() {
      const lista = confTheme[ref2]['redes-sociais'];
      if ($list.length > 0) {
        $list.html('');
        const formatClass = confTheme[ref2]['redes-format'];
        for (let i = 0; i < lista.length; i++) {
          if (lista[i].url != '' && lista[i].status == '1') {
            const item = `
            <a href="${lista[i].url}" rel="nofollow" target="_blank" class="social-icon ${formatClass}" title="${
              lista[i].titulo
            }">
              ${socialIconsSVG[lista[i].icon]}
            </a>`;
            $list.append(item);
          }
        }
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'redes-sociais-lista', changeList);
  }
})();

// ------------------------------------
// LINKS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'biolink-var';
    const ref2 = 'biolink';
    const refEvtPrefix = 'lp-evt-biolink-';

    // Elementos
    const $section = $('#biolink');
    const $element = $('.biolink-list');

    // Altera o formato dos links
    function changeBtnFormat() {
      const value = confTheme[ref2]['link-format'];
      $element.find('.biolink-item').removeClass('square rounded circle').addClass(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'link-format', changeBtnFormat);

    // Altera rotação seta
    function changeArrowRotate() {
      const value = confTheme[ref2]['arrow-rotate'];
      value == '1'
        ? $element.find('.biolink-item').addClass('arrow-rotate')
        : $element.find('.biolink-item').removeClass('arrow-rotate');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'arrow-rotate', changeArrowRotate);

    // Altera links centralizados
    function changeLinkCenter() {
      const value = confTheme[ref2]['link-center'];
      value == '1'
        ? $element.find('.biolink-item').addClass('link-center')
        : $element.find('.biolink-item').removeClass('link-center');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'link-center', changeLinkCenter);
  }
})();

// ------------------------------------
// LINKS (LISTA)
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'biolink-var';
    const ref2 = 'biolink';
    const refEvtPrefix = 'lp-evt-biolink-';

    // Elementos
    const $list = $('.biolink-list');

    // Altera a lista
    function changeList() {
      const lista = confTheme[ref2]['links'];
      if ($list.length > 0) {
        $list.html('');
        const arrowClass = confTheme[ref2]['arrow-rotate'] == '1' ? 'arrow-rotate' : '';
        const linkCenterClass = confTheme[ref2]['link-center'] == '1' ? 'link-center' : '';
        const formatClass = confTheme[ref2]['link-format'];
        for (let i = 0; i < lista.length; i++) {
          if (lista[i].url != '') {
            const bgColor = lista[i]['bg-color'];
            const borderColor = lista[i]['border-color'];
            const txtColor = lista[i]['txt-color'];
            const iconColor = lista[i]['icon-color'];
            const iconSize = lista[i]['icon-size'];
            const imgFullClass = lista[i]['image-full'] == '1' ? 'img-full' : '';

            let $itemInfos = '';
            if (lista[i]['icon-show'] == '1' && lista[i]['image-full'] == '1') {
              $itemInfos = `<figure class="biolink-item-img full">
                <img src="${lista[i]['image-src']}" alt="${lista[i]['image-alt']}" width="100%">
              </figure>`;
            } else {
              let $itemImg = '';
              if (lista[i]['icon-show'] == '1' && lista[i]['icon-type'] == 'icon') {
                $itemImg = `<figure class="biolink-item-icon">
                  ${getSvgIcon(lista[i]['icon'])}
                </figure>`;
              } else if (lista[i]['icon-show'] == '1' && lista[i]['icon-type'] == 'image') {
                $itemImg = `<figure class="biolink-item-img">
                  <img src="${lista[i]['image-src']}" alt="${lista[i]['image-alt']}" width="${iconSize}px">
                </figure>`;
              }
              $itemInfos = `<div class="biolink-item-infos">
                ${$itemImg}
                <div class="biolink-item-txt">${lista[i]['title']}</div>
              </div>`;
              let $itemArrow = '';
              if (lista[i]['show-arrow'] == '1') {
                $itemArrow = `<div class="biolink-item-arrow">
                  <svg class="i-arrow-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M 18.71875 6.78125 L 17.28125 8.21875 L 24.0625 15 L 4 15 L 4 17 L 24.0625 17 L 17.28125 23.78125 L 18.71875 25.21875 L 27.21875 16.71875 L 27.90625 16 L 27.21875 15.28125 Z"></path></svg>
                </div>`;
              }
              $itemInfos += $itemArrow;
            }

            const item = `<a href="${lista[i].url}" class="biolink-item ${formatClass} ${linkCenterClass} ${arrowClass} ${imgFullClass}" style="--bg-color: ${bgColor}; --border-color: ${borderColor}; --txt-color: ${txtColor}; --icon-color: ${iconColor}; --icon-size: ${iconSize}px;">
              ${$itemInfos}
            </a>`;
            $list.append(item);
          }
        }
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'lista', changeList);
  }
})();
